var resizeStep;
$('body').powerTour({
tours: [
{
trigger:"#tutorial",
startWith:1,
easyCancel:false,
escKeyCancel:true,
scrollHorizontal:false,
keyboardNavigation:true,
loopTour:false,
highlightStartSpeed:500,
highlightEndSpeed:500,
onStartTour:function(ui){ 
	$('#demo-filter').addClass('isDemo');
	isTour = true;
	$('#steps-footer').animate({bottom: 0},1000);
	$('.mainFilter[data-filter="admissions"]').trigger('click');
},
onEndTour:function(ui){
	if(!isTour){
		$('#demo-filter').removeClass('isDemo');
		$('#steps-footer').animate({bottom: '-70px'},1000);
		$('#filter-wrap, #demo-filter').removeClass('powertour-highlight').removeClass('powertour-hook');
	}
},
onProgress:function(ui){
	$('#demo-filter').addClass('isDemo');
	isTour = true;
	var i       = ui.stepIndex;
	tourStep = i;
	var total   = ui.totalSteps;
	var barSize = 100 / total * i+'%';

	$('#powertour-controls .selected').removeClass('selected');
	if(i <= 3 && i != 1){
		$('#powertour-controls .ptbutton[data-powertour-goto="2"]').addClass('selected');
	}else if(i >= 4 && i < 9){
		$('#powertour-controls .ptbutton[data-powertour-goto="4"]').addClass('selected');
	}else if(i >= 9 && i < 13){
		$('#powertour-controls .ptbutton[data-powertour-goto="9"]').addClass('selected');
	}else if(i >= 13 && i < 21){
		$('#powertour-controls .ptbutton[data-powertour-goto="13"]').addClass('selected');
	}else if(i >= 21 && i < 25){
		$('#powertour-controls .ptbutton[data-powertour-goto="21"]').addClass('selected');
	}else if(i >= 25){
		$('#powertour-controls .ptbutton[data-powertour-goto="25"]').addClass('selected');
	}

	// progress meter
	$('#progressmeter-text').html('<span id="step">'+i+'</span> / '+total+'').prev('#progressmeter-bar').animate({width: barSize},400);
},
steps: [
{
hookTo:"#",
content:"#step-one",
width:300,
position:"sc",
offsetY:0,
offsetX:0,
fxIn:"FadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){ },
onHideStep:function(ui){ }
},
{
hookTo:"#searchForm",
content:"#step-two",
width:300,
position:"bm",
offsetY:12,
offsetX:-9,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:150,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){ 
$('#from, #to').css('border', '1px solid #000');
},
onHideStep:function(ui){ 
$('#from, #to').css('border', '1px solid #b5b5b5');
}
},
{
hookTo:"#searchForm",
content:"#step-three",
width:300,
position:"br",
offsetY:12,
offsetX:2,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:false,
keepVisible:false,
onShowStep:function(ui){ 
	$('#from, #to').css('border', '1px solid #000');
	$('#setDates').addClass('blinkOB');
	tourTimeout = setTimeout(function(){
		$('#setDates').click();
	}, 5000);
},
onHideStep:function(ui){ 
	clearTimeout(tourTimeout);
	$('#from, #to').css('border', '1px solid #b5b5b5');
	$('#setDates').removeClass('blinkOB');
}
},
{
hookTo:"#graph-details",
content:"#step-four",
width:300,
position:"lm",
offsetY:0,
offsetX:5,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){ 
},
onHideStep:function(ui){ 
},
},
{
hookTo:"#graph-details",
content:"#step-five",
width:300,
position:"tm",
offsetY:12,
offsetX:-29,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#graph-details').addClass('tour-head');
	$('.dataTables_scrollHeadInner th').addClass('blinkOB');
},
onHideStep:function(ui){ 
	$('#graph-details').removeClass('tour-head');
	$('.dataTables_scrollHeadInner th').removeClass('blinkOB');
}
},
{
hookTo:"#graph-details",
content:"#step-six",
width:300,
position:"lt",
offsetY:65,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#resident-table .removePerson').addClass('blinkOBColor');
},
onHideStep:function(ui){ 
	$('#resident-table .removePerson').removeClass('blinkOBColor');
}
},
{
hookTo:"#graph-details",
content:"#step-seven",
width:300,
position:"lt",
offsetY:-18,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#graph-details i.refreshTable').parent().addClass('blinkWBColor');
},
onHideStep:function(ui){ 
	$('#graph-details i.refreshTable').parent().removeClass('blinkWBColor');
}
},
{
hookTo:"#refreshFilters",
content:"#step-eight",
width:300,
position:"tm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){

},
onHideStep:function(ui){ 

}
},
{
hookTo:'#graph-details',
content:"#step-facesheet-1",
width:300,
position:"lm",
offsetY:2,
offsetX:-1,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	
},
onHideStep:function(ui){

}
},
{
hookTo:'#facesheet-img-wrap',
content:"#step-facesheet-2",
width:300,
position:"rm",
offsetY:0,
offsetX:10,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
},
onHideStep:function(ui){
}
},
{
hookTo:'#personalInfo',
content:"#step-facesheet-3",
width:300,
position:"bm",
offsetY:-20,
offsetX:-150,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
},
onHideStep:function(ui){
}
},
{
hookTo:'#medicalInfo',
content:"#step-facesheet-4",
width:300,
position:"tm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
},
onHideStep:function(ui){
	$('#cancelButton').click();
}
},
{
hookTo:"#filter-wrap",
content:"#step-nine",
width:500,
position:"tm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	setTimeout(function(){
		$('.mainFilter[data-filter="admissions"]').trigger('click');
	}, 100);
	$('.mainFilter').addClass('blinkOB');
	$('#filter-wrap').addClass('powertour-hook').addClass('powertour-highlight').addClass('powertour-activehook');
},
onHideStep:function(ui){ 
	$('.mainFilter').removeClass('blinkOB');
	$('#filter-wrap').removeClass('powertour-hook').removeClass('powertour-highlight').removeClass('powertour-activehook');
}
},
{
hookTo:'#graphTypes',
content:"#step-twenty",
width:300,
position:"bm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#graphTypes li a').addClass('blinkOB');
},
onHideStep:function(ui){
	$('#graphTypes li a').removeClass('blinkOB');
}
},
{
hookTo:"#demo-filter",
content:"#step-ten",
width:300,
position:"rb",
offsetY:-22,
offsetX:10,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	tourTimeout = setTimeout(function(){
		$('#demo-filter .mainFilter').click();
		$.powerTour('navigation', 'next');
	}, 3000);
	$('#demo-filter').addClass('powertour-hook').addClass('powertour-highlight').addClass('powertour-activehook');
	$('#filter-wrap').removeClass('powertour-hook');
	$('#demo-filter').find('.mainFilter').data('demo', true);
},
onHideStep:function(ui){
	clearTimeout(tourTimeout);
	$('#demo-filter').removeClass('powertour-hook').removeClass('powertour-highlight').removeClass('powertour-activehook');
	$('#filter-wrap').addClass('powertour-hook');
}
},
{
hookTo:"#searchForm",
content:"#step-eleven",
width:300,
position:"bm",
offsetY:12,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	
},
onHideStep:function(ui){ 
	
}
},
{
hookTo:"#main-chart",
content:"#step-twelve",
width:500,
position:"bm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('.legend-box').css('opacity', '1');
},
onHideStep:function(ui){ 
	$('.legend-box').css('opacity', '0.8');
}
},
{
hookTo:'#main-chart',
content:"#step-thirteen",
width:300,
position:"rt",
offsetY:-40,
offsetX:10,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('.legend-box').css('opacity', '1');
},
onHideStep:function(ui){ 
	$('.legend-box').css('opacity', '0.8');
}
},
{
hookTo:'#main-chart',
content:"#step-fourteen",
width:300,
position:"lm",
offsetY:0,
offsetX:-470,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
},
onHideStep:function(ui){ 
}
},
{
hookTo:'#percents',
content:"#step-fifteen",
width:500,
position:"bm",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
},
onHideStep:function(ui){
}
},
{
hookTo:'#demo-filter',
content:"#step-sixteen",
width:300,
position:"lm",
offsetY:-230,
offsetX:12,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#filter-wrap').removeClass('powertour-highlight').removeClass('powertour-hook');
	$('#demo-filter').addClass('showfilters').addClass('powertour-highlight').addClass('powertour-hook').addClass('powertour-activehook');
	if(mainGraphFilter != 'lengthofstay'){
		$('.mainFilter[data-filter="lengthofstay"]').data('ignoreDemo', true).click();
	}
},
onHideStep:function(ui){
	$('#demo-filter').removeClass('showfilters').removeClass('powertour-highlight').addClass('powertour-hook').removeClass('powertour-activehook');
}
},
{
hookTo:'#demo-filter',
content:"#step-seventeen",
width:300,
position:"lm",
offsetY:-173,
offsetX:12,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#filter-wrap').removeClass('powertour-highlight').removeClass('powertour-hook');
	$('#demo-filter').addClass('showfilters').addClass('powertour-highlight').addClass('powertour-hook').addClass('powertour-activehook');
},
onHideStep:function(ui){
	$('#demo-filter').removeClass('showfilters').removeClass('powertour-highlight').addClass('powertour-hook').removeClass('powertour-activehook');
}
},
{
hookTo:'#demo-filter',
content:"#step-eighteen",
width:300,
position:"lm",
offsetY:-230,
offsetX:12,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	dc.filterAll();
	$('#filter-wrap').removeClass('powertour-highlight').removeClass('powertour-hook');
	$('#demo-filter').addClass('demo-open').addClass('showfilters').addClass('powertour-highlight').addClass('powertour-hook').addClass('powertour-activehook');
	$('#demo-filter, .physician-subfilter').addClass('showfilters');
	tourTimeout = setTimeout(function(){
		$('#demo-filter .physician-subfilter a').eq(0).click();
	}, 5000);
},
onHideStep:function(ui){
	$('#demo-filter').removeClass('showfilters').removeClass('powertour-highlight').addClass('powertour-hook').removeClass('powertour-activehook').removeClass('demo-open');
	$('#demo-filter, .physician-subfilter').removeClass('showfilters');
	clearTimeout(tourTimeout);
}
},
{
hookTo:'#currentFilters',
content:"#step-nineteen",
width:300,
position:"tl",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#filter-wrap').removeClass('powertour-highlight').removeClass('powertour-hook');
	if($('#currentFilters').css('display') == 'none'){
		$.powerTour('navigation', ["goto", 19]);
	}
	$(ui.currentStep).css('top', ($('#currentFilters').height() + 10)+'px');
	$('#currentFilters').addClass('blinkOB');
},
onHideStep:function(ui){
	$('#currentFilters').removeClass('blinkOB');
}
},
{
hookTo:'#print-button-wrap',
content:"#step-print-1",
width:300,
position:"tr",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	$('#print').addClass('blinkOB');
},
onHideStep:function(ui){
	$('#print').removeClass('blinkOB');
}
},
{
hookTo:'',
content:"#step-print-2",
width:300,
position:"sc",
offsetY:0,
offsetX:468,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){

},
onHideStep:function(ui){

}
},
{
hookTo:'',
content:"#step-print-3",
width:300,
position:"stl",
offsetY:0,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	resizeStep = ui.currentStep;
	resizePosition(true);
},
onHideStep:function(ui){

}
},
{
hookTo:'',
content:"#step-print-4",
width:300,
position:"stl",
offsetY:0,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	var current = ui.currentStep;
	var position = $('.hasResidents')[0].getBoundingClientRect();
	var left = position.left + position.width + 10;
	var top = position.top + ($('.scroll').height() / 2) - ($(current).height() / 2);
	$(current).css({'left': left+'px', 'top': top+'px'});
	var scrollTo = ($('#residents').height() / 2) + ($('#residents').height() / 4);
	$('#report-preview').scrollTop(scrollTo);
},
onHideStep:function(ui){

}
},
{
hookTo:'',
content:"#step-print-5",
width:300,
position:"stl",
offsetY:0,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	var current = ui.currentStep;
	var position = $('#printGo')[0].getBoundingClientRect();
	var left = position.left - position.width - ($(current).width() / 2) - 27;
	var top = position.top - $(current).height() - 10;
	$(current).css({'left': left+'px', 'top': top+'px'});
},
onHideStep:function(ui){

}
},
{
hookTo:'',
content:"#step-twentyone",
width:300,
position:"sc",
offsetY:10,
offsetX:0,
fxIn:"fadeIn",
fxOut:"fadeOut",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
timer:"00:00",
highlight:true,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){
	removePopUpAndOverlay();
},
onHideStep:function(ui){

}
},
],
stepDefaults: [
{
width:300,
position:"tl",
offsetY:0,
offsetX:0,
fxIn:"",
fxOut:"",
showStepDelay:0,
center:"step",
scrollSpeed:400,
scrollEasing:"swing",
scrollDelay:100,
timer:"00:00",
highlight:false,
keepHighlighted:true,
keepVisible:false,
onShowStep:function(ui){},
onHideStep:function(ui){}
}
]
}
]
});
function resizePosition(scrollTo){
	var current = $(resizeStep);
	var position = $('#chart-iamge')[0].getBoundingClientRect();
	var top = position.top + position.height + 10;
	var left = position.left + position.width - $(current).width() + 28;
	if(scrollTo){
		var scrollTo = ($('#chart-iamge').height() / 2) - 25;
		$('#report-preview').scrollTop(scrollTo);
		top = top - scrollTo;
	}
	current.css({'top': top+'px', 'left': left+'px'});
	//if it goes outside
	var scrollerTop = $('#report-preview')[0].getBoundingClientRect().top;
	var ourCurrentTop = resizeStep[0].getBoundingClientRect().top;
	if(ourCurrentTop <= scrollerTop){
		var difference = scrollerTop - ourCurrentTop;
		current.css('clip', 'rect('+difference+'px,auto,auto,auto)');
	}else{
		current.css('clip', 'rect(-10px,auto,auto,auto)');
	}
}